export const formatInvoiceProxyTimelineDate = (value) => {
  if (!value) {
    return '-';
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return String(value);
  }

  return new Intl.DateTimeFormat('id-ID', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(parsed);
};

export const pickInvoiceProxyTimelineList = (payload) => {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  const nested =
    payload.historyTimeline ||
    payload.timeline ||
    payload.steps ||
    payload.items ||
    payload.data;

  if (Array.isArray(nested)) {
    return nested;
  }

  if (nested && typeof nested === 'object') {
    return pickInvoiceProxyTimelineList(nested);
  }

  return [];
};

const resolveTimelineStatus = (item, index) =>
  item.statusLabel ||
  item.status ||
  item.approvalStatus ||
  item.decision ||
  `Step ${item.sequenceNo || index + 1}`;

const resolveTimelineActor = (item) => {
  const name = item.title || item.approverName || item.actor || '';
  const email =
    item.email || item.approverEmail || item.approverReference || '';

  if (name && email && name !== email) {
    return `${name} (${email})`;
  }

  return name || email || '-';
};

const resolveTimelineNotes = (item, status) => {
  const note = item.note || item.notes || item.remark || item.comment || '';
  const subtitle =
    item.subtitle && item.subtitle !== status ? item.subtitle : '';

  return [subtitle, note].filter(Boolean).join(' — ');
};

export const mapInvoiceProxyTimelineEvents = (payload) => {
  return pickInvoiceProxyTimelineList(payload).map((item, index) => {
    const status = resolveTimelineStatus(item, index);

    return {
      status,
      actor: resolveTimelineActor(item),
      notes: resolveTimelineNotes(item, status),
      date: formatInvoiceProxyTimelineDate(
        item.decidedAt || item.updatedAt || item.createdAt || item.date
      ),
    };
  });
};
